import { format, parseISO } from 'date-fns';

import { RosterRequestQuery } from 'generated/graphql';

type RequestedChangesProps = {
  request: RosterRequestQuery['rosterRequest'];
};

const RequestedChanges = ({ request }: RequestedChangesProps) => {
  if (request.requestData?.__typename !== 'RosterRequestDataDateChange') {
    return null;
  }

  return (
    <div className="col-span-3 col-start-1">
      <h2 className="mb-5 text-lg text-primaryGray">Requested Changes</h2>
      <div className="rounded-md border border-blue-200 bg-blue-50 p-5">
        {request.requestData?.checkInDate && (
          <p>
            New Check In Date:{' '}
            {format(parseISO(request.requestData.checkInDate), 'MM/dd/yyyy')}
          </p>
        )}
        {request.requestData?.checkOutDate && (
          <p>
            New Check Out Date:{' '}
            {format(parseISO(request.requestData.checkOutDate), 'MM/dd/yyyy')}
          </p>
        )}
      </div>
    </div>
  );
};

export default RequestedChanges;
